import * as types from '../mutation-types'
import api from '@/api/leaderboard'

// initial state
const state = {
    leaderboards: [],
    loaded: false,
}

const getters = {
    leaderboards: state => state.leaderboards,
    leaderboardsLoaded: state => state.loaded,
}

const actions = {
    getLeaderboards({ commit }) {
        commit(types.SET_LEADERBOARDS_LOADED, false );
        api.getLeaderboards({_embed: 1},(response) => {
            commit(types.SET_LEADERBOARDS, response._embedded.Quiz );
            commit(types.SET_LEADERBOARDS_LOADED, true );
        })
    },
}

const mutations = {
    [types.SET_LEADERBOARDS] (state, leaderboards ) {
        state.leaderboards = leaderboards
    },
    [types.SET_LEADERBOARDS_LOADED] (state, status ) {
        state.loaded = status
    },
}


export default {
    state,
    getters,
    actions,
    mutations
}


